export enum ParentStep {
  STEPS = 'steps',
  MANAGE = 'manage',
  TYP = 'typ',
}
